// extracted by mini-css-extract-plugin
export default {"wrapper":"quqd7qmqnR3aCs7Z1HeR","closed":"sOfbBIW6BZDSwJxgHD_v"};